const apiKey = "e15ceed836163cd1db523a673d8d81ea";

export default apiKey;
